'use strict';

require('./MenuListItem.scss');

const React = require('react'),
    Stamp = require('components/Commons/Stamps/Stamp/Stamp'),
    get = require('lodash/object').get,
    { PropTypes } = require('react');

const MenuListItem = React.createClass({displayName: "MenuListItem",
    propTypes: {
        item: PropTypes.object,
        index: PropTypes.number,
        isDisabled: PropTypes.bool,
        readerAttribute: PropTypes.string,
        readerAttributeIcon: PropTypes.string,
        onChange: PropTypes.func,
        wrapperMenuItem: PropTypes.func,
        key: PropTypes.string
    },

    shouldComponentUpdate() {
        if (!this.isMounted()) { // avoid several problem of rendering when try to call 'refs' which are not mounted yet
            return false;
        }
        return true;
    },

    onKeyDown(evt) {
        const { onChange, item, index } = this.props;
        const isKeyPressEnter = evt.keyCode === 13;
        const isKeyPressSpace = evt.keyCode === 32;
        const isKeyPressScape = evt.keyCode === 27;

        if (isKeyPressEnter || isKeyPressSpace || isKeyPressScape) {
            onChange(item, index);
        }
    },

    getTextItem(item, readerAttribute) {
        const { readerAttributeIcon, wrapperMenuItem } = this.props;
        const text = get(item, readerAttribute);
        const haveItems = !!get(item, readerAttributeIcon);
        const haveWrapperMenuItems = !!wrapperMenuItem;

        if (haveWrapperMenuItems) {
            return (
                React.createElement("span", {className: "bp-menu-list-item__content"}, 
                    wrapperMenuItem(item)
                )
            );
        } else if (haveItems) {
            return (
                React.createElement("span", {className: "bp-menu-list-item__content"}, 
                    React.createElement(Stamp, {classNameIcon: get(item, readerAttributeIcon)}), 
                    React.createElement("span", {className: "bp-menu-list-item__content-text"}, 
                        text
                    )
                )
            );
        } else {
            return (
                React.createElement("span", {className: "bp-menu-list-item__content"}, 
                    text
                )
            );
        }
    },

    onChange(evt) {
        const { onChange, item } = this.props;

        if (onChange) {
            onChange(item, evt);
        }
    },

    render() {
        const {
            item,
            readerAttribute,
            onChange,
            isDisabled,
            index,
            locatorId,
            key
        } = this.props;
        const textEl = this.getTextItem(item, readerAttribute, isDisabled);
        return (
            React.createElement("li", {
                "data-menu-index": index, 
                onKeyDown: isDisabled ? null : this.onKeyDown, 
                "data-locator-id": locatorId, 
                tabIndex: "0", 
                key: key + '-menu-item-id', 
                onClick: 
                    isDisabled
                        ? null
                        : onChange ? this.onChange : null, 
                
                className: 
                    'bp-menu-list-item' + (isDisabled ? ' is-disabled' : '')
                
            }, 
                textEl
            )
        );
    }
});

module.exports = MenuListItem;



/** WEBPACK FOOTER **
 ** ./src/components/Commons/MenuList/MenuListItem/MenuListItem.js
 **/